import { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";

import { useAppDispatch } from "../redux/hooks";
import { storeLocation } from "../redux/slices/applicationSlice";
import useResponsive from "./useResponsive";

import { buildRoutingPath } from "../utils/buildRoutingPath";
import { replace } from "../utils/navigate";
import { QueryParam, RoutingPath } from "../utils/types";

// redirects to the route page if the user is not on mobile
export const useRedirectToDesktopRoute = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { fromId, toId } = useParams();
  const { Mobile } = useResponsive();

  useEffect(() => {
    if (!Mobile) {
      const navigatePath = buildRoutingPath(RoutingPath.NAVIGATE, {
        fromId,
        toId,
      });

      dispatch(
        replace({
          pathOrLocation: navigatePath,
          discardParams: [QueryParam.MILESTONE_INDEX],
        }),
      );

      dispatch(storeLocation({ ...location, pathname: navigatePath }));
    }
  }, [Mobile, dispatch, fromId, location, toId]);
};
